<template>
  <div>
    <DataTableReportePartido default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable"
               slot-name="second-last-column">
        <span slot="after-filters">
            <v-tooltip bottom>
                <v-btn slot="activator" icon @click="downloadExcel" flat>
                    <v-icon color="primary">far fa-file-excel</v-icon>
                </v-btn>
                <span>Descargar XLS</span>
            </v-tooltip>
        </span>
         <template slot="second-last-column" slot-scope="props">
        <template >
          <td class="text-xs-center table-row" :key="'row-1'">
            {{cutCadena( props.item.observacion )}}
          </td>
        </template>
         <template >
          <td class="text-xs-center table-row " :key="'row-2'">
          <v-chip v-if="props.item.incumplimiento === 'Falta'" small text-color="white" color="red lighten-1">{{  props.item.incumplimiento}}</v-chip>
          <v-chip v-if="props.item.incumplimiento === 'Advertencia'" small text-color="black darken-2" color="yellow">{{  props.item.incumplimiento}}</v-chip>
          <v-chip v-if="props.item.incumplimiento === 'Ok'" class="v-chip-custom" small text-color="white darken-2" color="green">{{  props.item.incumplimiento}}</v-chip>
          </td>
        </template>
         <template >
          <td class="text-xs-center table-row " :key="'row-3'">
          <v-chip v-if="props.item.sanction === 'Incumplimiento'" small text-color="white" color="red lighten-1">{{  props.item.sanction}}</v-chip>
          <v-chip v-if="props.item.sanction === 'Revisado OK'" small text-color="white darken-2" color="green">{{  props.item.sanction}}</v-chip>
          <v-chip v-if="props.item.sanction === 'Advertencia'" small text-color="black darken-2" color="yellow">{{  props.item.sanction}}</v-chip>
          </td>
        </template>

      </template>
    </DataTableReportePartido>
  </div>
</template>

<script>
import DataTableReportePartido from '../../../common/ui/DataTableReportePartido'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTableReportePartido
  },

  data () {
    return {
      headers: [
        { text: 'Codigo', align: 'left', value: 'codigo', sortable: false },
        { text: 'Torneo', align: 'left', value: 'tournament', filterField: false },
        { text: 'Fecha', value: 'fecha', filterField: false },
        { text: 'Local', align: 'left', value: 'clubLocal', filterField: false },
        { text: 'Visitante', align: 'left', value: 'clubVisitor', filterField: false },
        { text: 'Dia y Hora', value: 'horario', filterField: false },
        { text: 'Descripcion', value: 'description', sortable: false },
        { text: 'Respuesta', align: 'left', value: 'value', filterField: false },
        { text: 'Observacion', value: 'observacion', filterField: false },
        { text: 'Incumplimiento', value: 'incumplimiento', filterField: false },
        { text: 'Sanción', value: 'sanction', filterField: false }
      ],
      properties: [ 'codigo',
        'tournament',
        'fecha',
        'clubLocal',
        'clubVisitor',
        'horario',
        'description',
        'value'
      ],
      path: 'reporte-informe-auditoria-partido',
      filterPath: 'filters/Informes-auditorias-partido'
    }
  },

  methods: {
    getExcelPath () {
      return 'reporte-incumplimientos/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'informes_faltas'
    },
    cutCadena (txt) {
      return txt.substring(0, 50) + ' ...'
    }
  }
}

</script>

<style scoped>
    .table-row {
        background-color: white;
        border-bottom: 1px solid #959ba6;
    }
    .table-row-no-contracts {
        background-color: #d0caca;
        border-bottom: 1px solid #959ba6;
    }

    .v-chip-custom{
      min-width: 85px;
      padding-left: 20px;
    }
</style>
